// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1uPWw","noInteraction":"EventWrapper_noInteraction__JYun9","pointerPassthrough":"EventWrapper_pointerPassthrough__1NK9M"};